import { render, staticRenderFns } from "./taskpackgeprice.vue?vue&type=template&id=a1851dc4&scoped=true&"
import script from "./taskpackgeprice.vue?vue&type=script&lang=js&"
export * from "./taskpackgeprice.vue?vue&type=script&lang=js&"
import style0 from "./taskpackgeprice.vue?vue&type=style&index=0&id=a1851dc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1851dc4",
  null
  
)

export default component.exports